import React from "react";
import { FormControlLabel, Checkbox } from "@mui/material";

export default function TSCheckbox({ label = "", ...rest }) {
    return <FormControlLabel label={label} className="mb-0" sx={{ m: 0 }} control={<Checkbox {...rest} />} />;
}
